/********************************************************************
 * Auto complete module
 *
 * Only show cities. If we also want to show courses we need
 * the get the bookable status before showing them in autocomplete.
 * Or find a way to make noticed that they do not have any
 * availability.
 *
 * OnFocus => - Check if users is loggedIn with MijnGolf.nl
 *				account
 *            - If so, toggle dropdown
 *            - load 'Laatst gekozen banen'
 *            - show 'Laatst gekozen banen'
 *
 * AfterXCharacters =>	- load 'auto complete courses'
 *						- show 'auto complete courses'
 *
 *	OnClick =>  - Select the option
 *				-  Fill CityId in FilterContext / Local Storage
 *
 ********************************************************************/
'use strict';

import { isElement, debounce, forEach } from 'lodash';
import { publish } from '../../01-helpers/event-manager';
import containerManager from '../../01-helpers/filter-context/container-manager';
import { addClass, removeClass, switchClass } from '../../01-helpers/utilities/class';
import { TOGGLE_CLOSE } from '../../02-const/event-names';

const
	moduleName = 'autocomplete',

	selectors = {
		base: `.js-${moduleName}`,
		trigger: `.js-${moduleName}__trigger`,
		container: `.js-${moduleName}__container`,
		listItem: `.js-listItem`
	},
	defaultConfig = {
		cssClasses: {
			closedClass: 'is-closed',
			openClass: 'is-open',
			overlayClass: 'has-overlay'
		}
	};

class AutoComplete {
	constructor(baseElement) {
		if (!isElement(baseElement)) {
			console.error(`Element has not been found.`);
			return false;
		}

		this.baseElement = baseElement;
		this.trigger = this.baseElement.querySelector(selectors.trigger);
		this.container = this.baseElement.querySelector(selectors.container);
		this.filterContext = containerManager.getContainer();

		this._bindEvents();
	}

	/**********************************************************************/
	openContainer() {
		switchClass(this.container, defaultConfig.cssClasses.closedClass, defaultConfig.cssClasses.openClass);
		switchClass(this.trigger, defaultConfig.cssClasses.closedClass, defaultConfig.cssClasses.openClass);
		addClass(document.body, defaultConfig.cssClasses.overlayClass);
	}

	closeContainer() {
		switchClass(this.container, defaultConfig.cssClasses.openClass, defaultConfig.cssClasses.closedClass);
		switchClass(this.trigger, defaultConfig.cssClasses.openClass, defaultConfig.cssClasses.closedClass);
		removeClass(document.body, defaultConfig.cssClasses.overlayClass);
	}
	/**********************************************************************/

	/**
	 * Blur event handler
	 *
	 * @param {any} evt
	 */
	_onBlurHandler(evt) {
		this.closeContainer();
	}

	/**
	 * Focus event handler
	 * @param {any} evt
	 */
	_onFocusHandler(evt) {
		publish(TOGGLE_CLOSE);
		// check if user is loggedin with his MijnGolf.nl account
		
	}

	/**
	 * Handler for Click event on ListItem
	 *
	 * @param {any} evt - Click (Mouse) event
	 */
	_onItemClickHandler(evt) {
		const element = evt.currentTarget || evt.target,
			id = element.dataset.id,
			value = element.dataset.value,
			filterContextField = this.baseElement.getAttribute('data-selection-type'),
			filterContextId = element.dataset?.attr ? JSON.parse(element.dataset.attr)['data-selection-id'] : this.baseElement.getAttribute('data-selection-id');
			
		// set the value of chosen item in the input as searchTerm
		this.trigger.value = value;

		this.filterContext.update({
			[filterContextField]: value,
			[filterContextId]: id
		});

		// close the container after a selection is made
		this.closeContainer();
	}

	/**
	 * KeyUp event handler
	 * @param {any} evt
	 */
	_onKeyUpHandler(evt) {
	}

	/**
	 * Set click event handler on listItems in the List
	 * @param {any} list - list that contains the listItems
	 */
	_setClickEvent(list) {
		const listItems = list.querySelectorAll(selectors.listItem);

		forEach(listItems, listItem => {
			listItem.addEventListener('click', (event) => {
				this._onItemClickHandler(event);
			});
		});
	}


	/**
	 * Bind event handling
	 **/
	_bindEvents() {
		// onfocus event handler
		this.trigger.addEventListener('focus', debounce(this._onFocusHandler.bind(this), 300, { 'leading': true, 'trailing': false }), true);
		this.trigger.addEventListener('blur', debounce(this._onBlurHandler.bind(this), 500, {'leading': false, 'trailing': true }), true);

		// onkeydown event handler
		this.trigger.addEventListener('keyup', debounce(this._onKeyUpHandler.bind(this), 300, { 'leading': false, 'trailing': true }));
	}
}

export default AutoComplete;